import { createSlice } from "@reduxjs/toolkit"
import {
  addGiftCard,
  deleteGiftCard,
  getAllGiftCardsUsage,
  getAllGiftsCards,
  getGiftCardDetails,
  getGiftCardUsageDetails,
  getGiftsCardList,
  updateGiftCard,
  updateGiftCardStatus,
} from "store/actions/giftCardAction"

const initialState = {
  loading: true,
  isLoading: false,
  itemsPerPage: 10,
  totalPages: null,
  currentPage: 1,
  totalCount: null,
  giftCards: [],
  giftCardDetails: {},
  giftCardsUsage: [],
  giftCardUsageDetails: {},
  giftCardList: [],
}

const usersSlice = createSlice({
  name: "gift card",
  initialState,
  reducers: {},
  extraReducers: builder => {
    // GET ALL
    builder
      .addCase(getAllGiftsCards.pending, state => {
        state.loading = true
      })
      .addCase(getAllGiftsCards.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload || {}
        if (status) {
          const { totalCount, totalPages, currentPage } = action.payload
          state.giftCards = data
          state.totalCount = totalCount
          state.totalPages = totalPages
          state.currentPage = currentPage
        }
      })
      .addCase(getAllGiftsCards.rejected, (state, action) => {
        state.loading = false
      })

    builder
      .addCase(getGiftsCardList.pending, state => {})
      .addCase(getGiftsCardList.fulfilled, (state, action) => {
        const { status, data } = action.payload || {}
        if (status) {
          state.giftCardList = data || []
        }
      })
      .addCase(getGiftsCardList.rejected, (state, action) => {})

    builder
      .addCase(addGiftCard.pending, state => {
        state.isLoading = true
      })
      .addCase(addGiftCard.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(addGiftCard.rejected, (state, action) => {
        state.isLoading = false
      })

    builder
      .addCase(updateGiftCard.pending, state => {
        state.isLoading = true
      })
      .addCase(updateGiftCard.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(updateGiftCard.rejected, (state, action) => {
        state.isLoading = false
      })

    builder
      .addCase(updateGiftCardStatus.pending, state => {
        state.isLoading = true
      })
      .addCase(updateGiftCardStatus.fulfilled, (state, action) => {
        state.isLoading = false
        const { status } = action.payload || {}
        if (status) {
          const { id, status } = action.meta.arg
          state.giftCards = state.giftCards.map(item =>
            item._id === id ? { ...item, status: Number(status) } : item
          )
        }
      })
      .addCase(updateGiftCardStatus.rejected, (state, action) => {
        state.isLoading = false
      })

    builder
      .addCase(getGiftCardDetails.pending, state => {
        state.loading = true
        state.giftCardDetails = {}
      })
      .addCase(getGiftCardDetails.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload || {}
        if (status) {
          state.giftCardDetails = data
        }
      })
      .addCase(getGiftCardDetails.rejected, (state, action) => {
        state.loading = false
      })

    builder
      .addCase(deleteGiftCard.pending, state => {
        state.isLoading = true
      })
      .addCase(deleteGiftCard.fulfilled, (state, action) => {
        const { status } = action.payload || {}
        const { id } = action.meta.arg
        state.isLoading = false
        if (status) {
          state.giftCards = state.giftCards.filter(item => item._id !== id)
          // Decrement the totalCount if it exists
          if (state.totalCount !== null) {
            state.totalCount -= 1
          }
        }
      })
      .addCase(deleteGiftCard.rejected, (state, action) => {
        state.isLoading = false
      })

    // GET ALL
    builder
      .addCase(getAllGiftCardsUsage.pending, state => {
        state.loading = true
      })
      .addCase(getAllGiftCardsUsage.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload || {}
        if (status) {
          const { totalCount, totalPages, currentPage } = action.payload
          state.giftCardsUsage = data
          state.totalCount = totalCount
          state.totalPages = totalPages
          state.currentPage = currentPage
        }
      })
      .addCase(getAllGiftCardsUsage.rejected, (state, action) => {
        state.loading = false
      })

    builder
      .addCase(getGiftCardUsageDetails.pending, state => {
        state.loading = true
        state.giftCardUsageDetails = {}
      })
      .addCase(getGiftCardUsageDetails.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload || {}
        if (status) {
          state.giftCardUsageDetails = data
        }
      })
      .addCase(getGiftCardUsageDetails.rejected, (state, action) => {
        state.loading = false
      })
  },
})

export default usersSlice.reducer
